import { useEntity } from '@backstage/plugin-catalog-react';

import { OwnershipStatusIndicator } from '../OwnershipStatusIndicator';
import { OWNERSHIP_STATUS_ANNOTATION } from '../../utils/ownershipStatus';

export const useOwnershipStatusIconLinkProps = () => {
  const { entity } = useEntity();
  const confirmed =
    entity.metadata.annotations?.[OWNERSHIP_STATUS_ANNOTATION] === 'confirmed';

  return {
    label: confirmed ? 'Ownership confirmed' : 'Ownership not confirmed',
    icon: (
      <OwnershipStatusIndicator
        isConfirmed={confirmed}
        className="tt-ownership-status"
      />
    ),
    disabled: true,
  };
};
